module.exports = __webpack_public_path__ + "img/no-instrument.3a1be435.png";